// extracted by css-extract-rspack-plugin
export default {"inputs":"AdAge-module__inputs--u3jQI"};